import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconBox} from '../../../../../libs/shared/ui/src/components/iconBox/iconBox';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SidePanelApplicationsManagerInfoBoxProps {
  isInfoBoxExpanded: boolean;
  onToggleInfoBox: () => void;
}

/*
 * Style.
 */

const StyledIconBoxWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
  padding-right: 16px;
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.small};
`;

const StyledDescriptionDiv = styled.div`
  font-size: ${fontSizes.verySmall};
`;

/*
 * Component.
 */

export const SidePanelApplicationsManagerInfoBox: FC<SidePanelApplicationsManagerInfoBoxProps> = (props) => {
  const {isInfoBoxExpanded, onToggleInfoBox} = props;

  if (!isInfoBoxExpanded) {
    return null;
  }
  return (
    <IconBox iconName="infoSmall" onRequestClose={onToggleInfoBox}>
      <StyledIconBoxWrapperDiv>
        <StyledTitleDiv>
          <Trans id="sidepanel-applications-manager-infobox-title">Prioritize your plugins</Trans>
        </StyledTitleDiv>
        <StyledDescriptionDiv>
          <Trans id="sidepanel-applications-manager-infobox-description">
            Did you know that you can re-order the plugins in your sidebar by dragging and dropping them in
            your desired location? Give it a try!
          </Trans>
        </StyledDescriptionDiv>
      </StyledIconBoxWrapperDiv>
    </IconBox>
  );
};
